var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Video = function Video(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 16 11' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M8 3H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm7 5.382L11 6.5V9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2.5l4-1.882v5.764zM12 3V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8l4 2V1l-4 2z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Video;
//# sourceMappingURL=Video.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Video.js